import axios from 'axios';
import { V1API } from '../../../_helpers/APIPath';
import { encode, decode } from '../../dataMagic';
import { populateStore, performNetworkCall, buildFormData } from '@/store/asyncHelper';



const mutations = {};
const store = {};

populateStore(store, mutations, false);

export default {
    namespaced: true,

    state : {
        changemakers: [],
        changemakerDetails: {},
        changemakerLoading: false,
        changemakerError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_CHANGEMAKER (state, items) {
            state.changemakers = items;
        },

        SET_CHANGEMAKER_DETAILS (state, details) {
            state.changemakerDetails = details;
        },

        CHANGEMAKER_LOADING (state, loading) {
            state.changemakerLoading = loading;
        },

        CHANGEMAKER_ERROR (state, hasError) {
            state.changemakerError = hasError;
        }
    },

    actions: {
        async fetchChangemakerList ({ commit }) {
            commit('CHANGEMAKER_LOADING', true);
            commit('CHANGEMAKER_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.changemaker_list, config);
                let response = result.data;

                commit('SET_CHANGEMAKER', response.data);

            } catch(error) {
                commit('CHANGEMAKER_ERROR', true);
            } finally {
                commit('CHANGEMAKER_LOADING', false);
            }
        },

        async fetchChangemakerDetails ({ commit }, payload) {
            commit('CHANGEMAKER_LOADING', true);
            commit('CHANGEMAKER_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.changemaker_details + payload, config);
                let response = result.data;

                commit('SET_CHANGEMAKER_DETAILS', response.data);

            } catch(error) {
                commit('CHANGEMAKER_ERROR', true);
            } finally {
                commit('CHANGEMAKER_LOADING', false);
            }
        },

        async deleteChangemaker({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.changemaker_delete + payload.delete_value, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchChangemakerList')
            return response
        },

        async updateStatusToggle({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };
            console.log(payload.delete);
            let response = await axios.get(V1API.changemaker_status_toggle + payload.changemaker_id, config).then(result=>{
                let data = result.data;
                return data;
            });

            dispatch ('fetchChangemakerList');
            dispatch ('fetchChangemakerDetails', payload.changemaker_id);

            return response;
        }
    },

    getters: {}
};
